var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v("© "+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":"https://davidlares.com"}},[_vm._v("David E Lares S")]),_vm._v(" | All rights reserved")])])}
var staticRenderFns = []

export { render, staticRenderFns }